import moment from "moment";

export const CURRENT_YEAR = moment(new Date()).year()
export const CURRENT_MONTH = (moment(new Date()).month() + 1)
